import { render, staticRenderFns } from "./episodic_memory_relational_icon.vue?vue&type=template&id=17c51c9e&"
import script from "./episodic_memory_relational_icon.vue?vue&type=script&lang=js&"
export * from "./episodic_memory_relational_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports